import React from 'react';
import PropTypes from 'prop-types';
import { flexbox, fontSize } from 'styled-system';
import styled from 'styled-components';
import { Box } from './common';
import { colors } from '@styles/theme';
import { HeadLine, Caption1 } from './Typography';

const Wrapper = styled(Box)`
  z-index: 2;
`;

const SegmentButton = styled('button')`
  height: 36px;
  display: flex;
  background: transparent;
  border: 0;
  &:enabled {
    color: ${props => (props.selected ? colors.darkGold : colors.lightGold)};
    border-bottom: 1px solid
      ${props => (props.selected ? colors.darkGold : 'transparent')};
  }

  outline: 0;
  &:hover,
  &:focus,
  &:active {
    border-bottom: 1px solid
      ${props => (props.selected ? colors.darkGold : 'transparent')};
  }
  ${flexbox}
  ${fontSize}
`;

function SegmentedControl(props) {
  const {
    segments,
    value,
    onChange,
    size,
    valueKey,
    labelKey,
    ...restProps
  } = props;

  const handleChangeSegment = segment => {
    if (!onChange) {
      return;
    }

    if (valueKey) {
      onChange(segment[valueKey]);
      return;
    }

    onChange(segment);
  };

  return (
    <Wrapper
      width={1}
      display="flex"
      flexDirection="row"
      justifyContent="center"
      {...restProps}
    >
      {segments.map(item => {
        let selected = item === value;
        let key = item;
        let itemLabel = item;

        if (valueKey) {
          selected = item[valueKey] === value;
          key = item[valueKey];
        }

        if (labelKey) {
          itemLabel = item[labelKey];
        }

        return (
          <SegmentButton
            flex={1}
            display="flex"
            fontSize={1}
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            key={key}
            selected={selected}
            onClick={
              !selected
                ? () => {
                    handleChangeSegment(item);
                  }
                : undefined
            }
          >
            {size === 'big' ? (
              <HeadLine>{itemLabel}</HeadLine>
            ) : (
              <Caption1>{itemLabel}</Caption1>
            )}
          </SegmentButton>
        );
      })}
    </Wrapper>
  );
}

SegmentedControl.propTypes = {
  segments: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string
};

export default SegmentedControl;
